import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { notificationService } from '../../services/notification.service';
import { useNotificationStore } from '../../store/notificationStore';
import { APP_CONFIG } from '../../config/api.config';

const AppShell: React.FC = () => {
  const { setUnreadCount } = useNotificationStore();

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const res = await notificationService.getUnreadCount();
        const count =
          res.data?.data?.unread_count ?? res.data?.unread_count ?? 0;
        setUnreadCount(count);
      } catch {
        // Silent fail
      }
    };

    fetchCount();
    const interval = setInterval(
      fetchCount,
      APP_CONFIG.NOTIFICATION_POLL_INTERVAL
    );
    return () => clearInterval(interval);
  }, [setUnreadCount]);

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: 'var(--bg-page)' }}>
      {/* Sidebar — fixed height, never scrolls */}
      <div
        style={{
          flexShrink: 0,
          height: '100vh',
          position: 'sticky',
          top: 0,
          zIndex: 40,
        }}
      >
        <Sidebar />
      </div>
      {/* Right side — header fixed, content scrollable */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          height: '100vh',
          position: 'relative',
          zIndex: 0,
        }}
      >
        <Header />
        <main
          className="page-container w-full"
          style={{ flex: 1, overflowY: 'auto' }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AppShell;
